// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"ebb75a7e","726":"8ddcd3e1"}[chunkId] + ".chunk.js";
};